import axios from 'axios';

const token = document.head.querySelector('meta[name="csrf-token"]');
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
if (token) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

const containers = document.querySelectorAll('.contact-form-component');

for (const container of containers)
{
    const formEl = container.querySelector('form');
    const submitBtEl = container.querySelector('.button-submit');
    const successMessageEl = container.querySelector('.form-message-sent');

    function submitHandler (event)
    {
        event.preventDefault();
        const formData = new FormData(formEl);
        const url = formEl.dataset.action;
        if (submitBtEl.classList.contains('disabled')) {
            return;
        }
        resetAllErrors();
        setLoadingState(true);
        axios.post(url, formData)
            .then((response) => submitSuccessHandler(response))
            .catch((error) => submitErrorHandler(error));
    }

    function submitSuccessHandler (response)
    {
        setLoadingState(false);
        deleteAllInputValues();
        successMessageEl.style.display = 'inline';
    }

    function submitErrorHandler (error)
    {
        setLoadingState(false);
        if (error.response.status == 422) {
            const errors = error.response.data.errors;
            for (const name in errors) {
                console.log(name);
                const inputEl = container.querySelector('[name="' + name + '"]');
                const errorEl = container.querySelector('.field-error-' + name);
                inputEl.classList.add('error');
                errorEl.style.display = 'block';
                errorEl.innerHTML = errors[name][0];
            }
        } else {
            alert('Unexpected error');
        }
    }

    function setLoadingState (b)
    {
        if (b) {
            container.style.opacity = .5;
            submitBtEl.classList.add('disabled');
        } else {
            container.style.opacity = 1;
            submitBtEl.classList.remove('disabled');
        }
    }

    function resetAllErrors ()
    {
        const inputs = container.querySelectorAll('input, textarea');
        const fieldErrors = container.querySelectorAll('.field-error');
        for (const input of inputs)
        {
            input.classList.remove('error');
        }
        for (const fieldError of fieldErrors)
        {
            fieldError.innerHTML = '';
            fieldError.style.display = 'none';
        }
        successMessageEl.style.display = 'none';
    }

    function deleteAllInputValues ()
    {
        const inputs = container.querySelectorAll('input, textarea');
        for (const input of inputs)
        {
            input.value = '';
            input.innerHTML = '';
        }
    }

    formEl.addEventListener('submit', submitHandler);

}
